/**
 * lib/prefs.ts — préférences d'interface qui doivent agir sur TOUTE la
 * plateforme.
 *
 * Elles ne passent pas par un contexte React : elles sont écrites en attribut
 * sur <html> et consommées en CSS. Un contexte obligerait à brancher chaque
 * composant un par un (et à re-rendre l'arbre à chaque changement) ; un
 * attribut agit d'un coup, y compris sur les pages qui ne connaissent pas la
 * préférence, et se pose AVANT l'hydratation — pas de bascule visible au
 * chargement (voir le bootstrap dans app/layout.tsx).
 */

export type Hand = 'right' | 'left';

export const HAND_KEY = 'ogryn:handedness';

export function readHand(): Hand {
  try { return localStorage.getItem(HAND_KEY) === 'left' ? 'left' : 'right'; } catch { return 'right'; }
}

/** Écrit la préférence ET l'applique immédiatement à toute l'interface. */
export function saveHand(v: Hand) {
  try { localStorage.setItem(HAND_KEY, v); } catch {}
  applyHand(v);
}

export function applyHand(v: Hand) {
  document.documentElement.dataset.hand = v;
}
